import { AuditReportLineRepairStatus } from '@wm-front/admin/graphql'
// eslint-disable-next-line @nx/enforce-module-boundaries
import { RepairStatusPipe } from '@wm-front/shared/pipes'

export function translateRepairStatus(
  status: AuditReportLineRepairStatus
): string {
  return new RepairStatusPipe().transform(status)
}
